/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */

import { Element } from './Element';
import { Vector2 } from 'three';
import { Hit } from './Hit';
import { MathUtils } from './MathsUtils';

export class Route {
  private points = new Array<Vector2>();
  private keys = new Array<number>();
  private times = new Array<number>();

  private goalPos: Vector2;
  private goalR: number;

  constructor(public endTime: number, public endDistance: number, public goal: any) {
    this.goalPos = new Vector2(goal.position[0], goal.position[1]);
    this.goalR = this.goal.radius;
  }

  getPoints (): Array<Vector2> {
    return this.points;
  }
  getKeys (): Array<number> {
    return this.keys;
  }
  getTimes (): Array<number> {
    return this.times;
  }

  calculate (point: Vector2, dir: Vector2, radius: number, elements: Array<Element>): boolean {
    let won = false;
    let bounceCount = 30; // not more than n bounces allowed
    let tAll = 0.0;

    let currPoint = point;
    let currDir = dir;
    this._setKeyFrame(point, 0);

    while (tAll < this.endDistance && (bounceCount--) > 0) {
      let bestHit = new Hit(new Vector2(), new Vector2(), -1);
      for (const elem of elements) {
        const hit = elem.checkHit(currPoint, currDir, radius);
        bestHit = Hit.improve(bestHit, hit);
      }

      const goalHit = MathUtils.checkCircleHit(currPoint, currDir, this.goalPos, this.goalR);
      // Goal
      if (Hit.lessThan(goalHit, bestHit) && ((tAll + goalHit.len) < this.endDistance)) {
        this._interp(currPoint, currDir, goalHit.len, tAll + goalHit.len, tAll);
        this._setKeyFrameWin();
        bounceCount = 0;
        won = true;
      } else if ((tAll + bestHit.len) < this.endDistance) {

        this._interp(currPoint, currDir, bestHit.len, tAll + bestHit.len, tAll);
        currPoint = bestHit.point;
        currDir = bestHit.dir;
      } else {
        const t = this.endDistance - tAll;

        this._interp(currPoint, currDir, t, this.endDistance, tAll);

      }
      tAll += bestHit.len;
    }
    return won;
  }

  private _distToTime (dist: number): number {
    const s = this.endDistance;
    const t = this.endTime;
    return (s * t - t * Math.sqrt(s * s - s * dist)) / s;
  }

  private _setKeyFrame (point: Vector2, dist: number) {
    this.points.push(point);
    this.keys.push(point.x, 0, point.y);
    this.times.push(this._distToTime(dist));
  }

  private _setKeyFrameWin () {
    const lasttime = this.times[this.times.length - 1] + 0.3;

    this.keys.push(this.goalPos.x, -this.goalR, this.goalPos.y);
    this.times.push(lasttime);
    this.keys.push(this.goalPos.x, -10, this.goalPos.y);
    this.times.push(lasttime + 0.5);
  }

  private _interp (p: Vector2, d: Vector2, diffT: number, endT: number, startT: number) {
    const step = 1;
    let stepAccu = step;
    while (stepAccu < diffT) {
      const ip = p.clone().add(d.clone().multiplyScalar(stepAccu));
      this._setKeyFrame(ip, startT + stepAccu);
      stepAccu += step;
    }
    const ip = p.clone().add(d.clone().multiplyScalar(diffT));
    this._setKeyFrame(ip, endT);

  }

}
